(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ncs-pose-link"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('ncs-pose-offer')) return;

    const formatMoney = (cents) => {
      if (window.NCS && typeof window.NCS.money === 'function') return window.NCS.money(cents);
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    };

    const ncsReady = () =>
      new Promise((resolve) => {
        if (window.NCS && window.NCS.addLines) {
          resolve(window.NCS);
          return;
        }
        document.addEventListener('ncs:ready', () => resolve(window.NCS), { once: true });
        setTimeout(() => resolve(window.NCS || null), 4000);
      });

    class NcsPoseOffer extends HTMLElement {
      connectedCallback() {
        this.busy = false;
        this.section = this.closest('.shopify-section');
        this.onClick = (event) => {
          const target = event.target instanceof Element ? event.target.closest('[data-plk-add]') : null;
          if (target && this.contains(target)) this.add(/** @type {HTMLButtonElement} */ (target));
        };
        this.onCart = (event) => {
          const promise = event.promise || Promise.resolve();
          promise.then(() => this.refresh()).catch(() => {});
        };
        this.onSelect = (event) => {
          if (!(event.target instanceof Element) || event.target.closest('product-card') || !event.promise) return;
          event.promise
            .then((result) => {
              const html = result && result.detail && result.detail.html;
              if (!html) return;
              const fresh = html.querySelector(`[data-ncs-sync="${this.dataset.ncsSync}"]`);
              if (!fresh) {
                this.hidden = true;
                return;
              }
              this.innerHTML = fresh.innerHTML;
              this.refresh();
            })
            .catch(() => {});
        };
        this.addEventListener('click', this.onClick);
        document.addEventListener('shopify:cart:lines-update', this.onCart);
        if (this.section) this.section.addEventListener('shopify:product:select', this.onSelect);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('shopify:cart:lines-update', this.onCart);
        if (this.section) this.section.removeEventListener('shopify:product:select', this.onSelect);
      }

      parts() {
        return Array.from(this.querySelectorAll('[data-plk-part]'));
      }

      /* Relit le panier : un produit deja au panier sort de la ligne */
      async refresh() {
        if (this.busy) return;
        let ids;
        try {
          const res = await fetch(`${this.dataset.cartUrl || '/cart'}.js`, { headers: { Accept: 'application/json' } });
          const cart = await res.json();
          ids = new Set((cart.items || []).map((item) => String(item.product_id)));
        } catch (error) {
          return;
        }
        this.parts().forEach((el) => {
          el.toggleAttribute('data-on', !ids.has(el.dataset.productId || ''));
        });
        this.paint();
      }

      paint() {
        const on = (role) => {
          const el = this.querySelector(`[data-plk-part="${role}"]`);
          return Boolean(el && el.hasAttribute('data-on'));
        };
        const baseOn = on('base');
        const topOn = on('top');
        this.hidden = !baseOn && !topOn;

        ['base', 'top'].forEach((role) => {
          const isOn = role === 'base' ? baseOn : topOn;
          const item = this.querySelector(`[data-plk-part="${role}"]`);
          const thumb = this.querySelector(`[data-plk-thumb="${role}"]`);
          if (item) item.hidden = !isOn;
          if (thumb) thumb.hidden = !isOn;
        });
        const plus = this.querySelector('[data-plk-plus]');
        if (plus) plus.hidden = !(baseOn && topOn);

        const title = this.querySelector('[data-plk-title]');
        if (title) {
          title.textContent = baseOn && topOn ? this.dataset.titleBoth : baseOn ? this.dataset.titleBase : this.dataset.titleTop;
        }
        const more = this.querySelector('[data-plk-more]');
        if (more) more.textContent = baseOn ? this.dataset.moreBase : this.dataset.moreTop;

        const lines = this.parts().filter((el) => el.hasAttribute('data-on'));
        const total = lines.reduce((sum, el) => sum + Number(el.dataset.price || 0), 0);
        const label = this.querySelector('[data-plk-label]');
        if (label) {
          label.textContent =
            lines.length > 1 ? `Ajouter les ${lines.length} · ${formatMoney(total)}` : `Ajouter · ${formatMoney(total)}`;
        }
      }

      async add(button) {
        if (this.busy) return;
        const lines = this.parts()
          .filter((el) => el.hasAttribute('data-on'))
          .map((el) => ({ id: Number(el.dataset.variantId), quantity: 1 }));
        if (!lines.length) return;
        const msg = this.querySelector('[data-plk-msg]');
        this.busy = true;
        button.classList.add('is-busy');
        button.setAttribute('aria-disabled', 'true');
        if (msg) msg.textContent = '';

        let result;
        const NCS = await ncsReady();
        if (NCS && NCS.addLines) {
          result = await NCS.addLines(lines, button);
        } else {
          /* Secours sans assets/ncs.js : ajout direct puis page panier */
          try {
            const res = await fetch(this.dataset.cartAddUrl || '/cart/add', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: lines }),
            });
            const json = await res.json();
            result = json.status ? { ok: false, message: json.description || json.message } : { ok: true };
            if (result.ok) window.location.assign(this.dataset.cartUrl || '/cart');
          } catch (error) {
            result = { ok: false, message: 'Connexion interrompue, réessayez.' };
          }
        }

        button.classList.remove('is-busy');
        button.removeAttribute('aria-disabled');
        if (result && result.ok) {
          button.classList.add('is-done');
          setTimeout(() => {
            button.classList.remove('is-done');
            this.busy = false;
            this.refresh();
          }, 1200);
        } else {
          this.busy = false;
          if (msg) msg.textContent = (result && result.message) || 'Ajout impossible pour le moment, réessayez.';
        }
      }
    }

    customElements.define('ncs-pose-offer', NcsPoseOffer);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ncs-price-ht"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('ncs-price-ht')) return;

    class NcsPriceHt extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section');
        if (!this.section) return;
        this.onSelect = (event) => {
          if (!(event.target instanceof Element) || event.target.closest('product-card') || !event.promise) return;
          event.promise
            .then((result) => {
              const html = result && result.detail && result.detail.html;
              if (!html) return;
              const fresh = html.querySelector(`[data-ncs-sync="${this.dataset.ncsSync}"]`);
              if (fresh) {
                this.innerHTML = fresh.innerHTML;
                this.hidden = false;
              } else {
                this.hidden = true;
              }
            })
            .catch(() => {});
        };
        this.section.addEventListener('shopify:product:select', this.onSelect);
      }

      disconnectedCallback() {
        if (this.section && this.onSelect) this.section.removeEventListener('shopify:product:select', this.onSelect);
      }
    }

    customElements.define('ncs-price-ht', NcsPriceHt);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ncs-product-heading"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('ncs-product-heading')) return;

    /* Titre propre dans la barre d'achat collante d'Horizon (elle affiche product.title, en capitales) */
    const applyStickyTitle = (el) => {
      const title = el.dataset.ncsTitle;
      const section = el.closest('.shopify-section');
      if (!title || !section) return;
      section.querySelectorAll('.sticky-add-to-cart__title').forEach((node) => {
        if (node.textContent.trim() !== title) node.textContent = title;
      });
    };

    class NcsProductHeading extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section');
        applyStickyTitle(this);
        if (!this.section) return;
        this.onSelect = (event) => {
          if (!(event.target instanceof Element) || event.target.closest('product-card') || !event.promise) return;
          event.promise
            .then((result) => {
              const html = result && result.detail && result.detail.html;
              const fresh = html ? html.querySelector(`[data-ncs-sync="${this.dataset.ncsSync}"]`) : null;
              if (fresh) this.innerHTML = fresh.innerHTML;
              /* Horizon reconstruit la barre collante dans la meme reponse : on repasse apres lui */
              setTimeout(() => applyStickyTitle(this), 0);
            })
            .catch(() => {});
        };
        this.section.addEventListener('shopify:product:select', this.onSelect);
      }

      disconnectedCallback() {
        if (this.section && this.onSelect) this.section.removeEventListener('shopify:product:select', this.onSelect);
      }
    }

    customElements.define('ncs-product-heading', NcsProductHeading);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ncs-shades"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('ncs-shade-picker')) return;

    class NcsShadePicker extends HTMLElement {
      connectedCallback() {
        const list = this.querySelector('.ncs-pshd__list');
        const nameEl = this.querySelector('[data-ncs-pshd-name]');
        if (!list) return;
        const initial = nameEl ? nameEl.textContent : '';

        /* Rail mobile : la teinte de la fiche visible au chargement, sans faire defiler la page */
        requestAnimationFrame(() => {
          const current = list.querySelector('[aria-current="true"]');
          if (!current || list.scrollWidth <= list.clientWidth) return;
          const item = current.parentElement;
          list.scrollLeft = Math.max(0, item.offsetLeft - (list.clientWidth - item.offsetWidth) / 2);
        });

        /* Apercu du nom au survol ou au focus d'une pastille ; le lien reste la seule action */
        if (!nameEl) return;
        const preview = (link) => {
          nameEl.textContent = link ? link.dataset.ncsName || initial : initial;
        };
        list.addEventListener('pointerover', (event) => {
          if (event.pointerType !== 'mouse' || !(event.target instanceof Element)) return;
          const link = event.target.closest('[data-ncs-name]');
          if (link) preview(link);
        });
        list.addEventListener('pointerleave', () => preview(null));
        list.addEventListener('focusin', (event) => {
          const link = event.target instanceof Element ? event.target.closest('[data-ncs-name]') : null;
          if (link) preview(link);
        });
        list.addEventListener('focusout', (event) => {
          if (!list.contains(/** @type {Node} */ (event.relatedTarget))) preview(null);
        });
      }
    }

    customElements.define('ncs-shade-picker', NcsShadePicker);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ncs-shipping"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('ncs-shipping-info')) return;

    const formatMoney = (cents) => {
      if (window.NCS && typeof window.NCS.money === 'function') return window.NCS.money(cents);
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    };

    /* Montant du panier renvoye par l'evenement standard (montant decimal, ex. "41.70") */
    const cartTotalCents = (cart) => {
      const amount = cart && cart.cost && cart.cost.totalAmount ? Number.parseFloat(cart.cost.totalAmount.amount) : NaN;
      return Number.isFinite(amount) ? Math.round(amount * 100) : null;
    };

    class NcsShippingInfo extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section');
        if (window.NCS && typeof window.NCS.init === 'function') window.NCS.init(this);

        this.onCart = (event) => {
          if (!event.promise) return;
          event.promise
            .then((result) => {
              if (!result || !result.cart) return;
              const total = cartTotalCents(result.cart);
              if (total !== null) this.paintGap(total, result.cart.totalQuantity);
            })
            .catch(() => {});
        };
        document.addEventListener('shopify:cart:lines-update', this.onCart);

        if (!this.section) return;
        this.onSelect = (event) => {
          if (!(event.target instanceof Element) || event.target.closest('product-card') || !event.promise) return;
          event.promise
            .then((result) => {
              const html = result && result.detail && result.detail.html;
              const fresh = html ? html.querySelector(`[data-ncs-sync="${this.dataset.ncsSync}"]`) : null;
              if (!fresh) return;
              this.innerHTML = fresh.innerHTML;
              if (window.NCS && typeof window.NCS.init === 'function') window.NCS.init(this);
            })
            .catch(() => {});
        };
        this.section.addEventListener('shopify:product:select', this.onSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:cart:lines-update', this.onCart);
        if (this.section && this.onSelect) this.section.removeEventListener('shopify:product:select', this.onSelect);
      }

      paintGap(totalCents, itemCount) {
        const line = this.querySelector('[data-ncs-pship-gap]');
        const threshold = Number(this.dataset.threshold || 0);
        if (!line || !threshold) return;
        if (!itemCount) {
          line.hidden = true;
          return;
        }
        const gap = threshold - totalCents;
        line.hidden = false;
        line.classList.toggle('is-reached', gap <= 0);
        line.textContent =
          gap > 0
            ? `Avec votre panier : encore ${formatMoney(gap)} pour la livraison offerte.`
            : 'Avec votre panier : livraison offerte en France métropolitaine.';
      }
    }

    customElements.define('ncs-shipping-info', NcsShippingInfo);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ncs-whatsapp"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('ncs-wa-help')) return;

    class NcsWaHelp extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section');
        if (!this.section) return;
        this.onSelect = (event) => {
          if (!(event.target instanceof Element) || event.target.closest('product-card') || !event.promise) return;
          event.promise
            .then((result) => {
              const html = result && result.detail && result.detail.html;
              const fresh = html ? html.querySelector(`[data-ncs-sync="${this.dataset.ncsSync}"]`) : null;
              if (!fresh) return;
              this.innerHTML = fresh.innerHTML;
              if (window.NCS && typeof window.NCS.init === 'function') window.NCS.init(this);
            })
            .catch(() => {});
        };
        this.section.addEventListener('shopify:product:select', this.onSelect);
      }

      disconnectedCallback() {
        if (this.section && this.onSelect) this.section.removeEventListener('shopify:product:select', this.onSelect);
      }
    }

    customElements.define('ncs-wa-help', NcsWaHelp);
  })();
  } catch(e) { console.error(e); }
})();

})();
